
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy-two",
      function () {
        return require("private-next-pages/policy-two.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy-two"])
      });
    }
  